<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'score',
    subject: 'Assessment',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-award-line',
  color: 'warning',
  title: 'Penilaian & Skoring (Assessment)',
  description: 'Menilai indikator, kinerja pegawai, atau vendor lewat template penilaian berbobot.',
  purpose: 'Menjelaskan cara kerja mesin penilaian yang sama, dipakai untuk tiga hal berbeda: Indikator Mutu, Kinerja Pegawai, dan Evaluasi Vendor.',
  concept: [
    {
      icon: 'ri-scales-3-line',
      title: 'Kriteria Berbobot',
      text: 'Satu template penilaian punya beberapa kriteria, masing-masing punya bobot (persen) yang totalnya harus 100%. Skor akhir dihitung otomatis dari nilai tiap kriteria dikalikan bobotnya.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Skala Berbeda, Hasil Tetap Adil',
      text: 'Satu kriteria bisa dinilai dengan skala 0-100, kriteria lain 1-5 — sistem otomatis menyesuaikan skalanya supaya bobot masing-masing tetap adil di skor akhir.',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → Penilaian, pilih Template', detail: 'Mis. "Penilaian Kinerja Pegawai".' },
    { title: 'Pilih subjek yang dinilai', detail: 'Bisa Pegawai, Vendor, atau Unit, tergantung jenis template-nya.' },
    { title: 'Isi nilai untuk setiap kriteria', detail: 'Perkiraan skor akhir langsung terlihat sambil Anda mengisi.' },
    { title: 'Klik "Simpan Penilaian"', detail: 'Skor akhir tersimpan dan bisa dilihat di grafik tren untuk subjek tersebut.' },
  ],
  tips: [
    'Cek grafik tren di halaman hasil sebelum menilai ulang — supaya Anda tahu apakah subjek ini membaik atau menurun dibanding periode sebelumnya.',
  ],
  faq: [
    { q: 'Kalau kriteria template diubah, apakah skor lama saya ikut berubah?', a: 'Tidak — skor yang sudah tersimpan tetap seperti semula, tidak ikut berubah walau bobot/kriteria template diedit belakangan.' },
  ],
  related: [
    { title: 'Self-Assessment Akreditasi', sub: 'Penilaian khusus standar akreditasi', icon: 'ri-medal-line', color: 'warning', to: { name: 'help-mutu-self-assessment-akreditasi' } },
    { title: 'Kelola Template Checklist', sub: 'Template mirip, untuk checklist', icon: 'ri-file-list-3-line', color: 'primary', to: { name: 'help-checklist-kelola-template-checklist' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
